export default {"src":"/_next/static/media/performanceOptimization.d21090e8.svg","height":1650,"width":2475,"blurWidth":0,"blurHeight":0};